import { render, staticRenderFns } from "./AudienceIndex.vue?vue&type=template&id=f535dc4a&scoped=true"
import script from "./AudienceIndex.vue?vue&type=script&lang=js"
export * from "./AudienceIndex.vue?vue&type=script&lang=js"
import style0 from "./AudienceIndex.vue?vue&type=style&index=0&id=f535dc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535dc4a",
  null
  
)

export default component.exports